/* dcent-product-card-grid.js — 추천 carousel nav (show_commerce 인스턴스).
   native scroll-snap 캐러셀의 prev/next 화살표 + 스크롤 위치에 따른 화살표 표시.
   prod EComposer "추천 제품" swiper의 횡스크롤+nav를 native로 재현 — Swiper/EComposer
   런타임 미사용. innerHTML 주입 0(XSS-safe), 외부 fetch 0. */
(function () {
  function initCarousel(viewport) {
    var track = viewport.querySelector("[data-pcg-track]");
    var prev = viewport.querySelector("[data-pcg-prev]");
    var next = viewport.querySelector("[data-pcg-next]");
    if (!track || !prev || !next) return;

    function step() {
      var item = track.querySelector(".dcent-product-card-grid__item");
      var w = item
        ? item.getBoundingClientRect().width
        : track.clientWidth * 0.8;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || "20") || 20;
      return w + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.hidden = track.scrollLeft <= 0;
      next.hidden = track.scrollLeft >= max;
    }

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function init() {
    var vps = document.querySelectorAll(
      ".dcent-product-card-grid__viewport--carousel",
    );
    Array.prototype.forEach.call(vps, initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
